import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    currentAudio: {},
    firstTrack: {},
    event: 'Paused...',
    broadcast: [],
    playlist: [],
    broadcastForAMonth: []
  },
  getters: {
  },
  mutations: {
    SET_CURRENT_AUDIO: (state, currentAudio) => {
      state.currentAudio = currentAudio
    },
    SET_EVENT: (state, event) => {
      state.event = event
    },
    SET_BROADCAST: (state, broadcast) => {
      state.broadcast = broadcast
    },
    SET_PLAYLIST: (state, playlist) => {
      state.playlist = playlist
    },
    SET_FIRST_TRACK: (state, firstTrack) => {
      state.firstTrack = firstTrack
    },
    SET_BROADCAST_FOR_A_MONTH: (state, broadcast) => {
      state.broadcastForAMonth = broadcast
    }
  },
  actions: {
    setCurrentAudio: ({commit}, currentAudio) => {
      commit('SET_CURRENT_AUDIO', currentAudio)
    },
    setEvent: ({commit}, event) => {
      commit('SET_EVENT', event)
    },
    setBroadcast: ({commit}, broadcast) => {
      commit('SET_BROADCAST', broadcast)
    },
    setPlaylist: ({commit}, playlist) => {
      commit('SET_PLAYLIST', playlist)
    },
    setFirstTrack: ({commit}, firstTrack) => {
      commit('SET_FIRST_TRACK', firstTrack)
    },
    setBroadcastForAMonth: ({commit}, broadcast) => {
      commit('SET_BROADCAST_FOR_A_MONTH', broadcast)
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/state/store.js